<template>
  <pt-poster-review class="pt-poster-review__page"></pt-poster-review>
</template>

<script>
import PtPosterReview from 'cps/tool-operation/pt-poster-review/withData'
export default {
  name: 'pt-poster-review__view',
  components: {
    'pt-poster-review': PtPosterReview
  }
}
</script>
